import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    templateUrl: './exception.component.html',
    standalone: false
})
export class ExceptionComponent implements OnInit {

    constructor(private routeLocation: Location, private router: Router) {}

    ngOnInit() {
        // this.appRef.tick();
    }

    goBack() {
        this.routeLocation.back();
    }

    goHome() {
        this.router.navigateByUrl('/');
    }
}
